import * as React from "react";
import _ from "lodash";
import moment from "moment";
import { FormProvider, useForm } from "react-hook-form";
import { SelectInput } from "../../components/forms/inputs/SelectInput";
import { ActionSpinner } from "../../components/ActionSpinner";

interface OwnProps {
  onSubmit: Function;
  onReset: Function;
}

const lastActivityChoices = [
  {
    label: "last day",
    value: moment().subtract(1, "day").startOf("day").format(),
  },
  {
    label: "3 days ago",
    value: moment().subtract(3, "days").startOf("day").format(),
  },
  {
    label: "week ago",
    value: moment().subtract(1, "week").startOf("day").format(),
  },
  {
    label: "month ago",
    value: moment().subtract(1, "month").startOf("day").format(),
  },
];

export const BeaconViewFiltersForm: React.FC<OwnProps> = (props) => {
  const methods = useForm({
    defaultValues: {
      filterByLastActivityFrom: "",
    },
  });

  return (
    // @ts-ignore
    <FormProvider {...methods}>
      <form className="card">
        <div className="card-header">
          <h3 className="card-title">Search</h3>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6 col-lg-4">
              <SelectInput
                name="filterByLastActivityFrom"
                options={lastActivityChoices}
                label="Last activity from"
              />
            </div>
          </div>
        </div>
        <div className="card-footer text-right">
          <div className="d-flex">
            <input
              className="btn btn-link"
              type="reset"
              value="Reset"
              onClick={(e) => {
                methods.reset();
                props.onReset(e);
              }}
            />
            <button
              type="button"
              onClick={methods.handleSubmit(
                (values: { filterByLastActivityFrom: string }) => {
                  let v = _.omitBy(values, (x) => x === "");
                  props.onSubmit(v);
                }
              )}
              disabled={methods.formState.isSubmitting}
              className="btn btn-primary btn-sm ml-auto"
            >
              {methods.formState.isSubmitting ? <ActionSpinner /> : "Search"}
            </button>
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export default BeaconViewFiltersForm;
